export default {
  falm: '免費取覽法律資訊',
  hklii23: '香港法律資訊中心 2023',
  banner_text: 'HKLII 感謝我們的贊助者支持「<b>免費取覽法律資訊：香港法律資訊中心 2023</b>」活動！',
  banner_btn: '贊助者',
  intro: "<p>二十多年來，HKLII 一直在香港免費提供法律資訊。沒有您的慷慨贊助，我們無法繼續我們的工作。</p><p>許多機構和人士為 HKLII 提供了寶貴的資金支持我們繼續發展。以下列出的 HKLII 贊助者將按英文字母順序排列。</p><p>我們衷心感謝您對 HKLII 的贊助和支持。</p>",
  sponsorcall: '贊助香港法律資訊中心',
  sponsorintro: '我們誠邀您從現在至 2023 年 12 月 31 日贊助「免費取覽法律資訊：香港法律資訊中心 2023」，條款如下：',
  term_recog_long: '在香港法律資訊中心網站鳴謝贊助：',
  term_recog_short: '在香港法律資訊中心網站鳴謝贊助',
  term_name: '公司名稱附超連結到贊助者的網站',
  term_logo: '公司標誌（{0}）附超連結到贊助者的網站',
  term_logo_l: '大',
  term_logo_m: '中',
  term_logo_s: '小',
  term_promo: '在其他宣傳資料（例如活動單張）顯示公司名稱/標誌',
  tier_diamond: '鑽石贊助',
  tier_diamond_amt: '港幣 5 萬元或以上',
  tier_platinum: '白金贊助',
  tier_platinum_amt: '港幣 3 萬元至港幣 49,999 元',
  tier_gold: '金贊助',
  tier_gold_amt: '港幣 1 萬元至港幣 29,999 元',
  tier_other: '其他贊助',
  tier_other_amt: '港幣 1 萬元以下',
  tax_deduction: '根據《稅務條例》第 88 條，贊助「免費取覽法律資訊：香港法律資訊中心 2023」，與向香港大學提供的其他捐款一樣，均可申請扣除稅項。',
  donateonline: '線上捐款',
  cheque_title: '支票捐款',
  cheque_text: '請將寫有「香港大學」為抬頭的支票郵寄給李秀雯女士，我們的辦公室地址是：',
  cheque_addr: '香港薄扶林道<br/>香港大學<br/>鄭裕彤教學樓10樓',
  enquire: '如需查詢，歡迎以電郵聯繫李秀雯女士 (<a href="mailto:lirachel@hku.hk">lirachel@hku.hk</a>)。',
}